import Vue from "vue";
import ApiService from "@/service/api";
import {postLoginRoute} from "@/utils/oauth_consent";

export const AuthService = {

    getBareToken() {
        return ApiService.get("/external/bare_token");
    },

    confirm_email(token, bare_token) {
        return ApiService.post(
            `/external/confirmation_token?bare_token=${bare_token}`,
            {confirmation_token: token}
        );
    },

    get_user() {
        return ApiService.get("external/user");
    },

    get_residential_credentials() {
        return ApiService.get("/external/residential/proxy_credentials");
    },

    reset_residential_credentials() {
        return ApiService.post("/external/residential/proxy_credentials");
    },

    get_datacenter_credentials() {
        return ApiService.get("/external/datacenter/proxy_credentials");
    },

    reset_datacenter_credentials() {
        return ApiService.post("/external/datacenter/proxy_credentials");
    },

    delete_user() {
        return ApiService.delete("external/user");
    },

    login(data, bare_token) {
        return Vue.auth.login({
            url: `/external/login?bare_token=${bare_token}`,
            data: data,
            redirect: postLoginRoute()
        });
    },

    social_login(data, bare_token) {
        return Vue.auth.oauth2(data.type, {
            url: `/external/login/social?bare_token=${bare_token}`,
            code: true,
            redirect: postLoginRoute(),
            state: data.state,
            data: {
                code: data.code,
                type: data.type,
                user_source: data.user_source,
                first_touch: data.first_touch
            }
        })
    },

    register(data, bare_token) {
        return Vue.auth.register({
            url: `/external/register?bare_token=${bare_token}`,
            data: data,
            autoLogin: false,
            redirect: null
        });
    },

    reset_email(email, bare_token) {
        return ApiService.post(
            `/external/forgot_password_email?bare_token=${bare_token}`,
            {email: email}
        )
    },

    resend_email(email, bare_token) {
        return ApiService.post(
            `/external/resend_confirmation_email?bare_token=${bare_token}`,
            {email: email}
        )
    },

    check_reset_token(token) {
        return ApiService.get(`/external/validate_forgot_password_token?token=${token}`);
    },

    set_new_password(params, bare_token) {
        return ApiService.post(
            `/external/set_forgot_password?bare_token=${bare_token}`,
            params
        );
    },

    change_password(params) {
        return ApiService.post("/external/change_password", params);
    },
};
